import axios from "axios";

export const state = {
    reportexpenses: [],
};

export const getters = {
    reportexpenses: state => state.reportexpenses,
};

export const mutations = {
    setReportExpense(reportexpenses, newValue) { state.reportexpenses = newValue},
};

export const actions = {
    fetchReportExpense({ commit }) {
        axios.get('/reportexpenses').then(res => {
            commit('setReportExpense', res.data.expensesales)
        })
    },
    filterReportExpense({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportexpenses";
        axios.post(url, formData).then((response) => {
            commit('setReportExpense', response.data.expensesales)
        })
    },
};
